<div class="card bcx-card p-4 mb-4">

  <!-- TITLE -->
  <h6 class="card-title fw-bold text-xs mb-3 d-flex align-items-center gap-2">
    <i class="fas fa-bolt text-warning fs-6"></i>
    Quick Actions
  </h6>

  <!-- ACTION GRID -->
  <div class="row g-3">

    <!-- LOOP: ACTION CARDS -->
    <div
      v-for="(action, index) in action_items"
      :key="index"
      class="col-6 col-md-4 d-flex"
    >
      <button
        type="button"
        class="btn card bcx-card d-flex flex-column justify-content-center align-items-center text-center w-100 py-3"
        @mouseenter="hover = index"
        @mouseleave="hover = null"
        :class="action.color_class"
      >
        <!-- Icon -->
        <i :class="action.icon" class="fs-4 mb-2"></i>

        <!-- Label -->
        <p class="fw-semibold text-xs mb-0">
          {{ action.label }}
        </p>

        <!-- Meta -->
        <p v-if="action.meta" class="text-secondary text-xxs mb-0">
          {{ action.meta }}
        </p>
      </button>
    </div>

    <!-- EMERGENCY CARD -->
    <div class="col-12 col-md-4 d-flex">
      <button type="button" class="btn card bcx-card qa-danger w-100 py-3 text-center">

        <!-- Icon -->
        <i class="bi bi-exclamation-triangle-fill fs-4 mb-2"></i>

        <!-- Label -->
        <p class="fw-semibold text-xs mb-0">
          Emergency Protocol
        </p>

      </button>
    </div>

  </div>
</div>
